import React, { useState, useEffect } from "react";
import "../styles/component.css";
import ContactForm from "./ContactForm.tsx";
import { MapPin } from 'lucide-react';

function Footer() {
  // View counter — persisted in localStorage
  const [viewCount, setViewCount] = useState(0);

  useEffect(() => {
    const key = 'mnh_view_count';
    const prev = parseInt(localStorage.getItem(key) || '0', 10);
    const next = prev + 1;
    localStorage.setItem(key, next);
    setViewCount(next);
  }, []);

  // Add state for form inputs and alert
  const [form, setForm] = useState({
    form_name: "",
    form_mobile: "",
    form_email: "",
    message: "",
    "h-captcha-response": ""
  });

  const [alert, setAlert] = useState({ type: "", message: "" });

  const handleChange = (e) =>
    setForm(prev => ({ ...prev, [e.target.name]: e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();

    const data = new FormData();
    data.append("access_key", "5a1a2686-9d7f-4f77-b37e-2b4d7082f111");
    data.append("form_name", form.form_name);
    data.append("form_mobile", form.form_mobile);
    data.append("form_email", form.form_email);
    data.append("message", form.message);
    data.append("h-captcha-response", form["h-captcha-response"]);
    data.append("subject", `'${form.form_name}' has submitted a query. Please review the query and respond to him/her by phone at '${form.form_mobile}' or by email at '${form.form_email}'`);
    data.append("body_type", "html");

    const res = await fetch("https://api.web3forms.com/submit", {
      method: "POST",
      body: data
    });

    const json = await res.json();

    if (json.success) {
      setAlert({ type: "success", message: "Message sent!" });
      setForm({ name: "", mobile: "", email: "", query: "" }); // optional reset
    } else {
      setAlert({ type: "danger", message: "Failed to send!" });
    }
  };


  return (
    <footer className="fooTer text-light text-center py-3 mt-4">
      <div className='footer-container' >
        <div className="footer-col footer-col-1">
          <div>
            <img
              src={require("../assets/img/Modern_Diagnostics_transparent_Logo.png")}
              alt="Modern Diagnostics Logo"
              className="footer-logo"
            />
          </div>
          <div>
            <p>Modern Diagnostics & Nursing Home Pvt. Ltd. is a trusted name in Birbhum district in healthcare for more than 20 years, especially in the field of Surgery, Medical Oncology and Radiology. It has state-of-the-art fully equipped modular operation theatres.</p>
          </div>
          <div className="socialIcon">
            <a
              href="https://www.facebook.com/modern.birbhum/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={require("../assets/img/socialMediaIcons/facebook.png")}
                alt="Facebook"
                className="footer-social-icon"
              />
            </a>
            <img
              src={require("../assets/img/socialMediaIcons/whatsapp.png")}
              alt="WhatsApp"
              className="footer-social-icon"
            />
            <img
              src={require("../assets/img/socialMediaIcons/instagram.png")}
              alt="Instagram"
              className="footer-social-icon"
            />
          </div>
        </div>
        <div className="footer-col footer-col-2">
          {/* Column 2 content */}
          <span><MapPin size={24} /> Location</span>
          {/* <ul className="footer-service-list">
            <li>General Surgery</li>
            <li>Laproscopic &amp; GI Surgery</li>
            <li>Onco-Surgery</li>
            <li>Pediatric Surgery</li>
            <li>URO-Surgery</li>
            <li>Orthopeadic Surgery</li>
            <li>Obstetric &amp; Gynocology</li>
            <li>Chemotherapy</li>
            <li>General Medicine</li>
            <li>Cardiology</li>
            <li>Medical Gasteroentrology</li>
            <li>Radiology</li>
            <li>Biocheistry &amp; Pathology</li>
          </ul> */}
          <p>Modern Diagnostics & Nursing Home Pvt. Ltd. Dangalpara, Suri, Birbhum- 731101 Besides Indusind Bank, opposite of HP petrol pump</p>
          <iframe
            src="https://maps.google.com/maps?q=Modern+Diagnostics+%26+Nursing+Home+Pvt.+Ltd.+Dangalpara,+Suri,+Birbhum-+731101&t=&z=15&ie=UTF8&iwloc=&output=embed"
            width="100%"
            height="200"
            style={{ border: 0, marginTop: "15px", borderRadius: "8px" }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="Google Map Location"
          ></iframe>
          <div className="view-counter">
            {/* <span className="view-counter-icon">&#128065;</span> */}
            <span className="view-counter-label">Total Visits :</span>
            <span className="view-counter-value">{viewCount.toLocaleString()}</span>
          </div>
        </div>
        <div className="footer-col footer-col-3" >
          <span>Contact us</span>
          <ContactForm
            form={form}
            alert={alert}
            handleChange={handleChange}
            handleSubmit={handleSubmit}
          />
        </div>
        <div className="row footer-bottom">
          <div className="row">
            <div className="footer-bottom-inner">
              <div className="footer-bottom-col">
                <p>© 2025 Modern Diagnostics & Nursing Home Pvt. Ltd. All rights reserved.</p>
              </div>
              <div className="text-end">
                <p>Design and Development by &nbsp;
                  <a href="http://www.codetunnel.co.in" target="_blank" rel="noopener noreferrer">
                    <img
                      src={require("../assets/img/logo-codetunnel.png")}
                      alt="CodeTunnel Logo"
                      className="footer-codetunnel-logo"
                      style={{ height: '30px', width: 'auto' }}
                    />
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <div className="footer-bottom">
        <p>© 2025 Medical Care. All rights reserved.</p>
      </div> */}
    </footer>
  );
}

export default Footer;
